import React from "react";

import {
  TextField,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
// import { TextField } from '@mui/material';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import axios from "axios";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { yupResolver } from "@hookform/resolvers/yup";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

import { Dialog, DialogContent, Icon, Toolbar } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import HomeIcon from "@mui/icons-material/Home";
import { B11VALIDATION } from "../../../Validation";
// import { FormControl } from "react-bootstrap";
import FormControl from "@mui/material/FormControl";
import { Box } from "react-bootstrap-icons";
import ComponentLoader from "../../../../ComponentLoader";

function B11Inside({ head }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = React.useState(false);

  const [Studentbtn, setStudentbtn] = useState([]);

  const [Titleoftheactionplan, setTitleoftheactionplan] = useState("");
  const [category, setcategory] = useState("");
  const [Centresinvolved, setCentresinvolved] = useState("");
  const [Progress, setProgress] = useState("");

  const [TitleoftheactionplanErr, setTitleoftheactionplanErr] = useState(false);
  const [CategoryErr, setCategoryErr] = useState(false);
  const [CentresinvolvedErr, setCentresinvolvedErr] = useState(false);
  const [ProgressErr, setProgressErr] = useState(false);
  const [loader,setLoader] =useState(true);
  const [state, setState] = useState();
  const [assM, setAssMonth] = useState("");
  const [invis, setInvestigator] = useState();


  const [LovCategory, setLovCategory] = useState([]);

  const [token, setToken] = useState("");
  const [id, setId] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  const toastSuccess = (data) => {
    toast.success(data, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(B11VALIDATION),
  });

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setToken(tok);
    console.log(tok);
    if (tok != null && tok != undefined) {
      // handleDirectorate(tok);
      handleLov(tok);
      console.log(location.state);
      if (location.state) {
        edit(location.state);
      }
    }
    head("MLT/OFT/Action Plan");
  }, []);

  useEffect(() => {
    const objectString = localStorage.getItem("MReport");
    const myObject = JSON.parse(objectString);
    if (myObject !== null) {
      setState(myObject);
    }
    const Month = localStorage.getItem("Month");
    if (Month !== null) {
      setAssMonth(Month);
    }
    const investigator = localStorage.getItem("loginId");
    setInvestigator(investigator);
  }, []);

  const edit = (item) => {
    console.log(item);
    setTitleoftheactionplan(item.titleoftheActionPlan);
    setcategory(item.category);
    setCentresinvolved(item.centresInvolved);
    setProgress(item.progress);
    setId(item.id);
  };

  // const SubmitBtn= () => {
  //   alert("Successfully Submitted");
  // }

  const handleBack = () => {
    navigate("/B11");
  };

  const handleClickOpen = () => {
    setOpen(true);
    //  navigate("/Activities")
  };

  const handleClose = () => {
    setOpen(false);
    // setId(0)
  };

  // Lov
  const handleLov = async (token, Category) => {
    console.log(token);

    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    try {
      const { data } = await axios.get(
        `${window.BASE}${window.LOVTYPE}${"Category"}`,
        {
          headers: h,
        }
      );
      console.log(data);
      setLovCategory(data);setLoader(false);
    } catch (error) {
      console.log(error);setLoader(false);
    }
  };

  const handleLeavepage = async () => {
    const h = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    console.log(token);
    const d = {
      id,
      TitleoftheActionPlan: Titleoftheactionplan,
      CentresInvolved: Centresinvolved,
      Progress: Progress,
      Category: category,
      MRSId: state.id,
      investigatorId: parseInt(invis),
      rptMonth: parseInt(assM),
    };
    if (id === 0) {
      try {
        const { data } = await axios.post(
          `${window.BASE}${window.B11SAVE}`,
          d,
          { headers: h }
        );
        console.log(data);
        setStudentbtn(data);

        if (data.result === "Success") {
          alert("Successfully Submitted");
          navigate("/B11");
          toastSuccess("Successfully Submitted");
          setId(0);
          setOpen(false);
        } else {
          // toastError(data.errorMsgs)
        }

        //   setDirect(data);
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const { data } = await axios.post(
          `${window.BASE}${window.B11EDIT}`,
          d,
          { headers: h }
        );
        console.log(data);

        if (data.result === "Success") {
          alert("Successfully Submitted");
          navigate("/B11");
          toastSuccess("Successfully updated");
          setId(0);
          setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const formValidateFun=()=>{
    if(!Titleoftheactionplan){
      setTitleoftheactionplanErr(true)
      document.getElementById("Titleoftheactionplan").focus()
    }else if(!category){
      setCategoryErr(true)
      document.getElementById("Category").focus()
    }else if(!Centresinvolved){
      setCentresinvolvedErr(true)
      document.getElementById("Centresinvolved").focus()
    }else if(!Progress){
      setProgressErr(true)
      document.getElementById("Progress").focus()
    }else{
      handleLeavepage()
    }
  }

  return (
    <div style={{ marginTop: 70 }}>
       <ComponentLoader isLoading={loader} />
      <div className="master-main d-flex">
        <div className="head-icon">
          <Link to="/monthyReport">
            <HomeIcon style={{ color: "white", marginLeft: 70 }} />
          </Link>
        </div>
        <div className="master-main-span">
          <span>MLT/OFT/Action Plan (B11)</span>
        </div>
      </div>

      <div className="from-mains">
        <div className="form-control">
          <h5 style={{ width: 450, margin: 20 }}>B11. MLT/OFT/Action Plan</h5>

          

          <TextField
            error={TitleoftheactionplanErr}
            id="Titleoftheactionplan"
            label="Title of the MLT/OFT/Action Plan"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={Titleoftheactionplan}
            onChange={(e) => {
              setTitleoftheactionplan(e.target.value)
              setTitleoftheactionplanErr(false)
            }}
          />

          <FormControl style={{ width: "48%", margin: 12 }} error={CategoryErr} id="Category">
            <InputLabel id="demo-simple-select-helper-label" size="small">
              Programme Type
            </InputLabel>
            <Select
              variant="outlined"
              // style={{ height: "45px" }}
              // sx={{ width: "48%",marginTop:"10px" }}
              value={category}
              placeholder="Programme Type"
              onChange={(e) => {
                setcategory(e.target.value)
                setCategoryErr(false)
              }}
            >
              {LovCategory?.map((option, index) => {
                return (
                  <MenuItem key={index} value={option.lovName}>
                    {option.lovName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          
          

          <TextField
            error={CentresinvolvedErr}
            id="Centresinvolved"
            label="Centres involved"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={Centresinvolved}
            onChange={(e) => {
              setCentresinvolved(e.target.value)
              setCentresinvolvedErr(false)
            }}
          />

          <TextField
            error={ProgressErr}
            id="Progress"
            label="Progress during the Month (Max 500 Character)"
            variant="outlined"
            style={{ margin: "10px", width: "48%" }}
            value={Progress}
            onChange={(e) => {
              setProgress(e.target.value)
              setProgressErr(false)
            }}
          />

          <div className="from-last">
            <button
              type="submit"
              onClick={handleBack}
              style={{paddingTop:"5px"}}
              className="deactivate-buttons"
            >
              Back
            </button>
            <button
              type="submit"
              className="sbmit-buttons"
              style={{paddingTop:"5px"}}
              onClick={()=>formValidateFun()}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default B11Inside;
